import { Box, Button, Typography } from "@mui/material";
import { Refresh } from "@mui/icons-material";

interface ErrorStateProps {
  message: string;
  onRetry?: () => void;
}

export default function ErrorState({ message, onRetry }: ErrorStateProps) {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "200px",
        gap: 2,
        p: 3,
      }}
    >
      <Typography variant="h6" color="error">
        Błąd
      </Typography>
      <Typography variant="body2" color="text.secondary" textAlign="center">
        {message}
      </Typography>
      {onRetry && (
        <Button variant="contained" startIcon={<Refresh />} onClick={onRetry} sx={{ mt: 1 }}>
          Spróbuj ponownie
        </Button>
      )}
    </Box>
  );
}
